import React from "react";
import Img from "gatsby-image";
import { Layout, Button } from "antd";

const { Header, Footer, Sider, Content } = Layout;

function ImageCard({
  id,
  title,
  image,
  buttonText,
  buttonLink,
  buttonLinkNewTab = true,
  buttonOnClick,
  buttonDownload = false,
  imageWidth = 300,
  height = 300,
  children,
}) {
  const borderRadius = "16px";
  var imageWidthStr = imageWidth + "px";
  var imageHeightStr = height + "px";

  return (
    <div className="max-w-md mx-auto bg-white rounded-xl shadow-xl overflow-hidden md:max-w-2xl transition transform hover:-translate-y-1 hover:shadow-2xl">
      <div className="md:flex">
        <div className="md:flex-shrink-0">
          <Img
            className="w-full h-full object-fill md:w-56"
            fluid={image}
            alt="image"
          />
        </div>
        <div className="md:flex-col md:relative">
          <div className="px-8 py-6">
            <p className="block my-0 text-2xl leading-tight font-medium text-black">
              {title}
            </p>
            <p className="mt-4 text-gray-500">{children}</p>
          </div>
          {buttonText !== undefined && <div className="md:py-5"></div>}
          {buttonText !== undefined && (
            <div className="px-8 pb-6 md:absolute md:bottom-0">
              <a
                target={buttonLinkNewTab ? "_blank" : ""}
                rel="noopener noreferrer"
                href={buttonLink}
                download={buttonDownload}
              >
                <button className="btn btn-blue" onClick={buttonOnClick}>
                  {buttonText}
                </button>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <Layout
      id={id}
      className="card"
      style={{
        borderRadius: borderRadius, // round edges
        WebkitBorderRadius: borderRadius,
        backgroundColor: "white",
        position: "relative", // for the button
        height: imageHeightStr,
        overflow: "hidden", // round the inner content too
      }}
    >
      <Sider
        style={{
          height: imageHeightStr,
          width: imageWidthStr,
          backgroundColor: "transparent",
        }}
      >
        <Img
          style={{
            height: imageHeightStr,
            width: imageWidthStr,
          }}
          fluid={image}
          alt="image"
        />
      </Sider>
      <Content
        style={{
          margin: "16px",
          paddingLeft: imageWidth - 200 + "px",
          marginBottom: buttonText != undefined ? "64px" : "16px",
        }}
      >
        <Content style={{}}>
          <h2>{title}</h2>
          {children}
        </Content>
      </Content>
      {/* TODO: Use Footer */}
      {buttonText != undefined ? (
        <Content>
          <a
            target={buttonLinkNewTab ? "_blank" : ""}
            rel="noopener noreferrer"
            href={buttonLink}
            download={buttonDownload}
          >
            <Button
              type="primary"
              onClick={buttonOnClick}
              style={{
                position: "absolute",
                bottom: "16px",
                left: imageWidth + 16 + "px",
              }}
            >
              {buttonText}
            </Button>
          </a>
        </Content>
      ) : undefined}
    </Layout>
  );
}
export default ImageCard;
